import { Data } from "./Type";

export const UNIFORM_REQUEST_TYPES = ['Complete Uniform', 'Pants Only', 'Top Only', 'Cap', 'Shoes'] as const;
export type UniformRequestType = typeof UNIFORM_REQUEST_TYPES[number];
export type UniformRequestStatus = 'New' | 'Processing' | 'Available' | 'Completed' | 'Cancelled';

export interface UniformRequest extends Data {
  id: string;
  idNumber: string;
  name: string;
  type: UniformRequestType;
  dateRequested: string; // ISO - UTC
  dateCompleted?: string; // ISO - UTC
  status: UniformRequestStatus;
}